import { render, staticRenderFns } from "./shipin.vue?vue&type=template&id=4afd4a3c&scoped=true&"
import script from "./shipin.vue?vue&type=script&lang=js&"
export * from "./shipin.vue?vue&type=script&lang=js&"
import style0 from "./shipin.vue?vue&type=style&index=0&id=4afd4a3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd4a3c",
  null
  
)

export default component.exports